/* eslint-disable shopify/prefer-early-return */
import ReactDOM from 'react-dom';
import React from 'react';
import Modal from 'react-modal';
import { fromEvent, merge } from 'rxjs';
import { distinctUntilChanged, map, sampleTime } from 'rxjs/operators';
import { CustomerSupportMenuContainer } from '../biotrust/headerMenu';
import { registerCustomEventHandler } from '../biotrust/trackers/customEventHandler';
export function Header() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    accountNavigation: '.site-header__cart-wrapper',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavDropDown: '.site-nav__dropdown',
    siteNavChildLastLink: '.site-nav__link--last',
    siteNavChildFirstLink: '.site-nav__link--first'
  };
  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };
  var cache = {};

  function init(container) {
    cacheSelectors();
    observeDropDown($('#site-nav-ACCOUNT'), $('#SiteNavLabel-my-account'));
    observeDropDown($('#site-nav-shop'), $('#SiteNavLabel-shop'));
    observeDropDown($('#site-nav-biotrust'), $('#SiteNavLabel-biotrust'), 14);
    renderCustomerSupportDropDown(); // Init Navigation Menu Test Dropdowns

    observeDropDown($('#site-nav-proteins'), $('#SiteNavLabel-proteins'), 14);
    observeDropDown($('#site-nav-anti-aging'), $('#SiteNavLabel-anti-aging'), 14);
    observeDropDown($('#site-nav-digestive-health'), $('#SiteNavLabel-digestive-health'), 14);
    observeDropDown($('#site-nav-immune-support'), $('#SiteNavLabel-immune-support'), 14); // Init Navigation Menu V2 Test Dropdowns

    observeDropDown($('#site-nav-best-sellers'), $('#SiteNavLabel-best-sellers'), 14);
    observeDropDown($('#site-nav-weight-management'), $('#SiteNavLabel-weight-management'), 14);
    observeDropDown($('#site-nav-movement-energy'), $('#SiteNavLabel-movement-energy'), 14);
    observeDropDown($('#site-nav-wellness-essentials'), $('#SiteNavLabel-wellness-essentials'), 14);
    observeDropDown($('#site-nav-about-us'), $('#SiteNavLabel-about-us'), 14);
    observeDropDown($('#site-nav-benefits'), $('#SiteNavLabel-benefits'), 14);
    observeDropDown($('#site-nav-healthy-aging'), $('#SiteNavLabel-healthy-aging'), 14); // Deal with click and enter events

    cache.$parents.on('click.siteNav', function (evt) {
      var $el = $(this);

      if (!$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }
    }); // ENTER KEY IS PRESSED ON BUTTONS WITH DROPDOWN MENU ITEMS

    cache.$parents.on('keyup.siteNav', function (evt) {
      if (evt.keyCode === 13) {
        switch (this.id) {
          case 'site-nav-shop':
            if (!$('#SiteNavLabel-shop').hasClass(config.activeClass)) {
              showDropDown($('#SiteNavLabel-shop'), $(this));
              $('#SiteNavLabel-shop').find('li').find('a').first().focus();
            }

            break;

          case 'site-nav-biotrust':
            if (!$('#SiteNavLabel-biotrust').hasClass(config.activeClass)) {
              showDropDown($('#SiteNavLabel-biotrust'), $(this), 14);
            }

            $('#SiteNavLabel-biotrust').find('li').find('a').first().focus();
            break;

          case 'site-nav-ACCOUNT':
            if (!$('#SiteNavLabel-my-account').hasClass(config.activeClass)) {
              showDropDown($('#SiteNavLabel-my-account'), $(this));
            }

            $('#SiteNavLabel-my-account').find('li').find('a').first().focus();
            break;

          default:
            break;
        }
      }
    }); // check when we are leaving a dropdown on first element and close active dropdown and highlight nav parent

    $(selectors.siteNavChildFirstLink).on('focusout.siteNav', function () {
      var _this = this;

      setTimeout(function () {
        if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        switch (_this.closest(selectors.siteNavDropDown).id) {
          case 'SiteNavLabel-my-account':
            $('#site-nav-ACCOUNT').focus();
            break;

          case 'SiteNavLabel-shop':
            $('#site-nav-shop').focus();
            break;

          case 'SiteNavLabel-biotrust':
            $('#site-nav-biotrust').focus();
            break;

          default:
            break;
        }

        hideDropdown(cache.$activeDropdown);
      }, 50);
    }); // check when we're leaving a dropdown on last element and close the active dropdown
    // then change the focus to the next element
    // The reason the logic below is written is because the dropdowns are no longer children of the siteNav

    $(selectors.siteNavChildLastLink).on('focusout.siteNav', function () {
      var _this2 = this;

      setTimeout(function () {
        if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        switch (_this2.closest(selectors.siteNavDropDown).id) {
          case 'SiteNavLabel-my-account':
            $('.site-header__cart').focus();
            break;

          case 'SiteNavLabel-shop':
            $(selectors.siteNavLinkMain, '#AccessibleNav').first().focus();
            break;

          case 'SiteNavLabel-biotrust':
            $('#bt-snize-search-input').first().focus();
            break;

          default:
            break;
        }

        hideDropdown(cache.$activeDropdown);
      }, 50);
    }); // close dropdowns when on top level nav

    cache.$topLevel.on('focus.siteNav', function () {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    }); // fire custom events to GA to track navigation item clicks
    // NOTE: Be sure to register this handler before the one below, which stops event propagation

    registerCustomEventHandler(container);
    cache.$subMenuLinks.on('click.siteNav', function (evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).add(selectors.accountNavigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function observeDropDown($trigger, $dropdown) {
    var topOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    return merge(fromEvent([$trigger, $dropdown], 'mouseenter').pipe(map(function () {
      return true;
    })), fromEvent([$trigger, $dropdown], 'mouseleave').pipe(map(function () {
      return false;
    }))).pipe(sampleTime(50), distinctUntilChanged()).subscribe(function (show) {
      if (show) {
        showDropDown($dropdown, $trigger, topOffset);
      } else {
        hideDropdown($dropdown);
      }
    });
  }

  function showDropDown($dropdown, $trigger) {
    var topOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var rect = $trigger.get(0).getBoundingClientRect();
    var top = rect.bottom - 14 + topOffset;
    var position = {
      top: "".concat(top, "px")
    }; // if dropdown is not full width & centered (3 level nav), then set left position

    if (!$dropdown.hasClass('site-nav__dropdown--centered')) {
      position.left = "".concat(rect.left, "px");
    }

    $dropdown.addClass(config.activeClass);
    $dropdown.css(position); // close open dropdowns

    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $dropdown; // set expanded on open dropdown

    $dropdown.attr('aria-expanded', 'true');
    setTimeout(function () {
      $(window).on('keyup.siteNav', function (evt) {
        if (evt.keyCode === 27) {
          hideDropdown($dropdown); // RESET FOCUS BACK TO BUTTON DROPDOWN

          switch ($dropdown[0].id) {
            case 'SiteNavLabel-my-account':
              $('#site-nav-ACCOUNT').focus();
              break;

            case 'SiteNavLabel-shop':
              $('#site-nav-shop').focus();
              break;

            case 'SiteNavLabel-biotrust':
              $('#site-nav-biotrust').focus();
              break;

            default:
              break;
          }
        }
      });
      $(selectors.body).on('click.siteNav', function () {
        hideDropdown($dropdown);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass); // reset active dropdown

    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);
    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function renderCustomerSupportDropDown() {
    Modal.setAppElement(document.body);
    var customerSupportTrigger = document.getElementById('site-nav-CUSTOMER-SUPPORT');
    var customerSupportMobileTrigger = $('a.site-header__customer-support-mobile').get(0);
    var nextFocusElem = document.getElementById('site-nav-ACCOUNT');
    var componentContainer = document.createElement('div');
    document.body.appendChild(componentContainer);
    ReactDOM.render( /*#__PURE__*/React.createElement(CustomerSupportMenuContainer, {
      triggerElem: customerSupportTrigger,
      mobileTriggerElem: customerSupportMobileTrigger,
      nextFocusElem: nextFocusElem
    }), componentContainer);
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLastLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
}